"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgCutOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M25.47 19.75L19.53 16l5.92-3.73c3.28-2.18 2.74-4.58 1.71-6.21a4.06 4.06 0 00-2.54-2 4.94 4.94 0 00-3.76 1c-3.29 2.19-2.75 4.59-1.72 6.22a4.58 4.58 0 001.57 1.56l-3.07 1.93L5.53 7.15l-1.06 1.7L15.79 16 4.47 23.14l1.06 1.69 12.13-7.65 3.07 1.93a4.58 4.58 0 00-1.57 1.56c-1 1.63-1.57 4 1.72 6.22a5.56 5.56 0 003 1.1 4.39 4.39 0 00.72-.07 4.09 4.09 0 002.54-2c1.07-1.59 1.61-3.99-1.67-6.17zm-3.35-8.43a2.16 2.16 0 01-1.27-1.07C20.12 9.1 20 8.06 22 6.77A3.16 3.16 0 0124.22 6a2.13 2.13 0 011.27 1.1c.73 1.15.81 2.18-1.12 3.48a3.17 3.17 0 01-2.25.74zm3.37 13.57A2.13 2.13 0 0124.22 26a3.16 3.16 0 01-2.22-.78c-1.95-1.3-1.87-2.33-1.14-3.48a2.16 2.16 0 011.27-1.07 1.39 1.39 0 01.3 0 3.71 3.71 0 011.91.75c1.96 1.29 1.88 2.32 1.15 3.47z" })));
}
exports.default = SvgCutOutline;
//# sourceMappingURL=CutOutline.js.map